import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CompareIcon(props: IconProps) {
    return <Icon {...props} iconKey={"compare"}/>
}
